/* Minimal inline markdown: **bold**, *italic*, `code`, [text](href).

   Emphasis carries no styling of its own — `.prose strong`, `.blockBody
   .inlineCode` and friends style it from context, so the same lesson text
   renders correctly on a light page, inside an inverted NOTICE block, and on
   the dark exercise screen without the caller passing colours down.
*/

import { InlineCode } from '../design/primitives.jsx';

const PATTERN = /(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`|\[[^\]]+\]\([^)]+\))/g;

export function inline(text) {
  if (text == null) return null;
  if (typeof text !== 'string') return text;
  return text.split(PATTERN).filter(Boolean).map((p, i) => {
    /* Recurse into emphasis: `code` inside **bold** is common in this content
       and rendered its backticks literally when this was a single pass. */
    if (p.startsWith('**') && p.endsWith('**')) return <strong key={i}>{inline(p.slice(2, -2))}</strong>;
    if (p.startsWith('*') && p.endsWith('*') && p.length > 2) return <em key={i}>{inline(p.slice(1, -1))}</em>;
    if (p.startsWith('`') && p.endsWith('`')) return <InlineCode key={i}>{p.slice(1, -1)}</InlineCode>;
    const link = /^\[([^\]]+)\]\(([^)]+)\)$/.exec(p);
    if (link) {
      const external = /^https?:/.test(link[2]);
      return <a key={i} href={link[2]} {...(external ? { target: '_blank', rel: 'noreferrer' } : {})}>{link[1]}</a>;
    }
    return <span key={i}>{p}</span>;
  });
}

export const Inline = ({ children }) => <>{inline(children)}</>;
